import React, { useState, useEffect } from 'react';
import { Button } from './ui/button';
import { Download, X, Smartphone } from 'lucide-react';

const InstallPrompt = () => {
  const [deferredPrompt, setDeferredPrompt] = useState(null);
  const [showPrompt, setShowPrompt] = useState(false);

  useEffect(() => {
    // Don't show if already installed or dismissed recently
    const dismissed = localStorage.getItem('pwa_install_dismissed');
    if (dismissed && Date.now() - parseInt(dismissed) < 7 * 24 * 60 * 60 * 1000) return;

    const handler = (e) => {
      e.preventDefault();
      setDeferredPrompt(e);
      // Show after a delay so it doesn't appear immediately
      setTimeout(() => setShowPrompt(true), 5000);
    };

    window.addEventListener('beforeinstallprompt', handler);
    return () => window.removeEventListener('beforeinstallprompt', handler);
  }, []);

  const handleInstall = async () => {
    if (!deferredPrompt) return;
    deferredPrompt.prompt();
    const { outcome } = await deferredPrompt.userChoice;
    if (outcome === 'accepted') {
      setShowPrompt(false);
    }
    setDeferredPrompt(null);
  };

  const handleDismiss = () => {
    setShowPrompt(false);
    localStorage.setItem('pwa_install_dismissed', Date.now().toString());
  };

  if (!showPrompt) return null;

  return (
    <div className="fixed bottom-20 left-4 right-4 sm:left-auto sm:right-6 sm:w-80 z-50 animate-in slide-in-from-bottom duration-500">
      <div className="bg-emerald-700 text-white rounded-2xl shadow-2xl p-4 flex items-start gap-3">
        <div className="w-10 h-10 bg-white/20 rounded-xl flex items-center justify-center flex-shrink-0">
          <Smartphone className="w-5 h-5" />
        </div>
        <div className="flex-1">
          <p className="font-bold text-sm">Install Creassion</p>
          <p className="text-emerald-100 text-xs mt-0.5">Add to your home screen for quick access — works offline too!</p>
          <div className="flex gap-2 mt-3">
            <Button onClick={handleInstall} size="sm" className="bg-white text-emerald-700 hover:bg-emerald-50 rounded-lg text-xs h-8 px-3">
              <Download className="w-3 h-3 mr-1" /> Install App
            </Button>
            <Button onClick={handleDismiss} variant="ghost" size="sm" className="text-emerald-200 hover:text-white hover:bg-white/10 rounded-lg text-xs h-8">
              Not Now
            </Button>
          </div>
        </div>
        <button onClick={handleDismiss} className="text-emerald-300 hover:text-white"><X className="w-4 h-4" /></button>
      </div>
    </div>
  );
};

export default InstallPrompt;
